export const ORGANISATION_SETTINGS_LOAD_REQUEST = 'ORGANISATION_SETTINGS_LOAD_REQUEST';
export const ORGANISATION_SETTINGS_LOAD_SUCCESS = 'ORGANISATION_SETTINGS_LOAD_SUCCESS';
export const ORGANISATION_SETTINGS_LOAD_FAILURE = 'ORGANISATION_SETTINGS_LOAD_FAILURE';
